/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import {
	CosmosButton,
	CosmosRichText,
	CosmosTextVariantEnum,
	TextLinkAndChevron,
	TextLinkAndChevronProps,
} from "@components/elements";
import { CosmosElementLearnDocumentationCardFragment } from "@cosmos/hygraph-schema";
import { cx, css } from "@panda/css";
import { flex } from "@panda/patterns";
import { SystemStyleObject } from "@panda/types";

export const cardStyle: SystemStyleObject = {
	w: "full",
	h: "full",
	padding: "eds.dimension.24",
	bgColor: "eds.background.elevated.high.default",
	borderRadius: "eds.borderRadius.24",
	borderColor: "eds.palette.transparent.light.005",
	borderWidth: "1px",

	display: "flex",
	flexDir: "column",
	alignItems: "flex-start",

	"& > *:nth-child(2)": { flexGrow: 1 },
	xlDown: {
		flexDir: "row",
		justifyContent: "space-between",
		columnGap: "eds.dimension.32",

		"& > *:nth-child(1)": { flexGrow: "1" },
		"& > *:nth-child(2)": { flexShrink: "0" },
	},
	mdDown: {
		flexDir: "column",
	},
};

export const contentStyle: SystemStyleObject = {
	flexDir: "column",
	gap: "eds.dimension.16",
};

export const linksStyle: SystemStyleObject = {
	display: "flex",
	flexDir: "column",
	flexWrap: "nowrap",
	alignItems: "flex-start",
	rowGap: "eds.dimension.8",
	columnGap: "eds.dimension.8",
};

export function DocumentCard({
	description,
	links = [],
	cta,
}: CosmosElementLearnDocumentationCardFragment): React.JSX.Element {
	return (
		<div className={cx("document-card", css(cardStyle))}>
			<div className={cx(flex({}), css(contentStyle))}>
				<CosmosRichText variant="paragraphSM" {...description} />
				<div>
					<div className={cx("links", css(linksStyle))}>
						{
							// Assigned a default value to links so it will never be null
							(links as TextLinkAndChevronProps[]).map((link: TextLinkAndChevronProps, i) => (
								<TextLinkAndChevron key={`link-${i}`} textVariant={CosmosTextVariantEnum.paragraphSM} {...link} />
							))
						}
					</div>
				</div>
			</div>
			<div
				className={cx(
					"cta",
					flex({ justifyContent: "flex-end", alignItems: "flex-end" }),
					css({
						paddingTop: "eds.dimension.16",
					}),
				)}
			>
				<CosmosButton {...cta} />
			</div>
		</div>
	);
}
